import { Row } from 'react-bootstrap';

import { AppBar, Button, Card, CardContent, Grid, Stack, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import DatalysLogo from '../../assets/DatalysLogo.png';
import HTHlogo from '../../assets/logo.png';
import RIOlogo from '../../assets/RIOlogo.png';

const Footer = () => {
  const theme = useTheme();
  return (
    <Box>
      <Card sx={{ backgroundColor: 'primary.main' }}>
        <Grid container direction="row" justifyContent="space-around">
          <Grid item md={3}>
            <Button href="https://www.datalyscenter.org/index.php" target='_blank' sx={{ textTransform: 'none' }}>
              <Stack direction="column">
                <Typography color="white" variant="caption">
                  Data captured by:
                </Typography>
                <img src={DatalysLogo} width="160px" height="40px"></img>
              </Stack>
            </Button>
          </Grid>
          <Grid item md={3}>
            <Stack direction="column">
              <Typography color="white" variant="caption">
                Data captured via:
              </Typography>
              <Typography sx={{ fontSize: '0.1rem' }}>
                <img src={RIOlogo} width="160px" height="50px"></img>
              </Typography>
            </Stack>
          </Grid>

          <Grid item>
            <Button href="https://www.headstogetherhealth.com" target='_blank' sx={{ textTransform: 'none' }}>
              <Stack direction="column">
                <Typography color="white" variant="caption">
                  Data visualization enabled by:
                </Typography>
                <Grid sx={{ height: '50px' }}>
                  <img src={HTHlogo} height="70px" width="100px"></img>
                </Grid>
              </Stack>
            </Button>
          </Grid>
        </Grid>
        <Typography variant="caption" color="white" sx={{ flexGrow: 1, justifyContent: 'center', display: 'flex' }}>
          2023 Datalys, inc. © All Rights Reserved.
        </Typography>
      </Card>
    </Box>
  );
};

export default Footer;
